<template>
  <div class="hub-update">
    <div v-if="items && items.length">
      <TitleBlock :text="titleText" :link="searchLink" />
      <div v-for="(item, index) in items" :key="index" class="row">
        <Update
          :class="{
            'hub-informative-update': item.classification === 'Informative',
            'hub-indicative-update': item.classification === 'Indicative',
            'hub-actionable-update': item.classification === 'Actionable',
          }"
          :date="item.publishDate ? item.publishDate : null"
          :title="item.title"
          :link="item.url"
          :has-access="hasAccess"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HubUpdate",
  props: {
    titleText: {
      type: String,
      default: null,
    },
    searchLink: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: null,
    },
    hasAccess: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
.hub-update {
  border: 1px dashed $border;

  .row {
    margin-left: 2rem;
    padding-bottom: 1rem;
  }

  .hub-actionable-update:after {
    background: $actionable;
  }

  .hub-indicative-update:after {
    background: $indicative;
  }

  .hub-informative-update:after {
    background: $informative;
  }
}
</style>
